var _defs, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSoundOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_19371",
    "data-name": "Group 19371",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.089,
    height: 19.452,
    viewBox: "0 0 22.089 19.452",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7527",
    "data-name": "Path 7527",
    className: "cls-1",
    d: "M35.487,25.258a.676.676,0,0,0-.7.039l-6.821,4.639h-3.2A2.965,2.965,0,0,0,21.81,32.9v4.016a2.965,2.965,0,0,0,2.962,2.962h3.2l6.821,4.639a.669.669,0,0,0,.38.118.691.691,0,0,0,.317-.078.676.676,0,0,0,.36-.6v-18.1A.669.669,0,0,0,35.487,25.258Zm-1,17.411-5.936-4.035a.669.669,0,0,0-.38-.118H24.768a1.6,1.6,0,0,1-1.6-1.6v-4.02a1.6,1.6,0,0,1,1.6-1.6h3.409a.651.651,0,0,0,.38-.118l5.936-4.035Z",
    transform: "translate(-21.81 -25.18)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7528",
    "data-name": "Path 7528",
    className: "cls-1",
    d: "M69.628,35.049A8.71,8.71,0,0,0,66.282,31.1a.678.678,0,0,0-.729,1.144,7.348,7.348,0,0,1,0,12.4.678.678,0,0,0,.364,1.25.689.689,0,0,0,.364-.106,8.787,8.787,0,0,0,1.481-1.187,8.707,8.707,0,0,0,1.865-9.544Z",
    transform: "translate(-48.224 -28.713)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7529",
    "data-name": "Path 7529",
    className: "cls-1",
    d: "M64.59,42.4a5.792,5.792,0,0,0-2.739-4.788.678.678,0,0,0-.729,1.144,4.2,4.2,0,0,1,0,7.287.678.678,0,0,0,.364,1.25.689.689,0,0,0,.364-.106A5.792,5.792,0,0,0,64.59,42.4Z",
    transform: "translate(-45.53 -32.679)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSoundOn);
export default __webpack_public_path__ + "static/media/Icon_SoundON.bbdb50a40f2e8c23618eacd957351b30.svg";
export { ForwardRef as ReactComponent };